import { Component, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { smoothlyMenu } from '../../../app.helpers';
import 'jquery-slimscroll';
import { SfhSecurityService } from '@sasser/sfh-shared-security';
import { style, transition, animate, trigger, group, query } from '@angular/animations';
import { SignalRService } from '../notification/signal-r.service';
import { SharedModule } from '../../../../app/shared/shared.module';
import { AppChatPanelComponent, provideAgenticChatTheme } from '@sasser/sfh-agentic-ui';

declare var jQuery: any;

const RAIL360_CHAT_THEME = {
	background: '#2f4050',
	text: '#dfe4ed',
	muted: '#a7b1c2',
	userBackground: '#1ab394',
	userForeground: '#ffffff',
	inputBackground: '#253746',
	border: '#3d5266',
	chipBackground: '#253746',
	accent: '#1ab394',
	connected: '#1ab394',
} as const;

@Component({
	standalone: true,
	imports: [SharedModule, AppChatPanelComponent],
	providers: [provideAgenticChatTheme(RAIL360_CHAT_THEME)],
	selector: 'navigation',
	templateUrl: 'navigation.template.html',
	changeDetection: ChangeDetectionStrategy.Default,
	animations: [
		trigger('notificationCounterChange', [
			transition(':increment', group([
			  	query(':enter', [
					style(
						{
							fontSize: '30px',
							// padding: '0 10px'
						}
					),
					animate('0.8s ease-out', style('*'))
				])
			]))
		])
	]
})

export class NavigationComponent implements AfterViewInit, OnInit {

	public showNotifications = false;
	showCategoryNotifications = false;
	assistantActive = false;
	assistantLoaded = false;
	navCollapsed = false;
	get notificationCategories() {
		return this.hubConnectionService.getNotificationsCategories();
	}
	get pbiCommercialRpts() {
		return this.hubConnectionService.getPbiCommercialRpts();
	}
	get pbiFleetRpts() {
		return this.hubConnectionService.getPbiFleetRpts();
	}
	get groupByCategory() {
		return this.hubConnectionService.getGroupByCategory();
	}
	get isNotificationFetched(){
		return this.hubConnectionService.notificationFetched;
	}

  	constructor(
	  private router: Router,
	  public sfhAuth: SfhSecurityService,
	  private cdRef: ChangeDetectorRef,
	  private hubConnectionService: SignalRService
	) {	}

	ngOnInit(): void {
		this.hubConnectionService.connect();
		
		if (this.sfhAuth.isAuthenticated()) {
			setTimeout(() => {
				jQuery('li a', '#side-menu').on('click', function () {
					const anchor = jQuery(this);
					const parentLi = anchor.parent('li');
					const subMenu = anchor.next('ul');
					if (subMenu && subMenu.hasClass('mm-collapse')) {
						if (subMenu.hasClass('mm-show')) {
							subMenu.metisMenu().data('metisMenu').hide(subMenu);
							anchor.attr('aria-expanded', false);
							parentLi.removeClass('mm-active');
						} else {
							subMenu.metisMenu().data('metisMenu').show(subMenu);
							anchor.attr('aria-expanded', true);
							parentLi.addClass('mm-active');
						}
					}
				});

				// Add event listener to fix height issue for menus with mm-show
				// and sync mm-active class with mm-show state for proper arrow icon display
				const sideMenu = document.getElementById('side-menu');
				if (sideMenu) {
					const observer = new MutationObserver(() => {
						// Fix height issue
						jQuery('#side-menu .mm-show').each((_index: number, element: HTMLElement) => {
							const $el = jQuery(element);
							if ($el.css('height') === '0px') {
								$el.css('height', '');
							}
						});

						// Sync mm-active class with mm-show state for proper arrow icons
						jQuery('#side-menu .mm-collapse').each((_index: number, element: HTMLElement) => {
							const $submenu = jQuery(element);
							const $parentLi = $submenu.parent('li');

							if ($submenu.hasClass('mm-show')) {
								// Submenu is expanded, ensure parent has mm-active for arrow icon
								if (!$parentLi.hasClass('mm-active')) {
									$parentLi.addClass('mm-active');
								}
							} else {
								// Submenu is collapsed, remove mm-active from parent
								const hasArrow = $parentLi.find('> a > .fa.arrow').length > 0;
								if (hasArrow && $parentLi.hasClass('mm-active')) {
									$parentLi.removeClass('mm-active');
								}
							}
						});
					});
					observer.observe(sideMenu, { childList: true, subtree: true, attributes: true });
				}
			}, 200);
		}	
	}

	ngAfterViewInit() {
		jQuery('#side-menu').metisMenu();
		jQuery('#side-menu-account').metisMenu();

		if (jQuery('body').hasClass('fixed-sidebar')) {
			jQuery('.sidebar-collapse').slimscroll({
				height: '100%'
			});
		}
		this.cdRef.detectChanges();
	}

	activeRoute(routename: string, queryParam?: string): boolean {
		if (queryParam) {
			switch (routename) {
				case 'pbiReport':
					routename = routename + `?id=${queryParam}`;
					break;
				default:
					break;
			}
		}
		return this.router.url.indexOf(routename) > -1;
	}

	getPageHeight() {
		return window.innerHeight;
	}

	get env() {
		if(window.location.host.includes('rail360.crdx.com'))
		{
			return 'PROD';
		}

		if(window.location.host.includes('localhost'))
		{
			return 'DEV';
		}
		
		//for Rail360-QA, UAT, Stage & Hotfix etc. Environment. e.g. rail360-hotfix.crdx.com
		return window.location.host.split('.')[0].split('-')[1]?.toUpperCase();
	}

	get userInfo() {
		return this.sfhAuth.userInfo;
	}

	get canDebugAIChatAssistant(): boolean {
		return this.sfhAuth.isAuthenticated() && this.sfhAuth.hasPermissions('CanDebugAIChatAssistant');
	}

	get canUseAIChatAssistant(): boolean {
		return this.sfhAuth.isAuthenticated() && this.sfhAuth.hasPermissions('CanUseAIChatAssistant');
	}

	logout() {
		this.sfhAuth.logout();
	}

	toggleNavigation(): void {
		jQuery('body').toggleClass('mini-navbar');
		this.navCollapsed = jQuery('body').hasClass('mini-navbar');

		// The collapsed rail is 70px wide, which cannot host the chat panel.
		if (this.navCollapsed) {
			this.assistantActive = false;
		}

		smoothlyMenu();
		this.cdRef.detectChanges();
	}

	showMenu(): void {
		this.assistantActive = false;
		this.cdRef.detectChanges();
	}

	showAssistant(): void {
		if (!this.canUseAIChatAssistant) {
			return;
		}

		if (this.navCollapsed) {
			jQuery('body').removeClass('mini-navbar');
			this.navCollapsed = false;
			smoothlyMenu();
		}

		this.assistantLoaded = true;
		this.assistantActive = true;
		this.cdRef.detectChanges();
	}

	toggleNotifications(): void {
		this.showNotifications = !this.showNotifications;
		this.cdRef.detectChanges();
	}

	get notificationCount(): number {
		return this.sumByProperty(this.notificationCategories, 'count');
	}

	private sumByProperty(items, prop): number {
		return items.reduce( function(a, b) {
			return a + b[prop];
		}, 0);
	}
}
